<ng-container *ngIf="rates">
    <table class="table table-bordered table-sm" id="projet">
        <caption>Taux de fiabilité</caption>
        <thead>
            <th id="year"> Année </th>
            <th id="month"> Mois </th>
            <th id="installs"> Installations (M + M-1)</th>
            <th id="failures"> Défaillances </th>
            <th id="rates"> Taux de Fiabilité </th>
        </thead>
        <tr *ngFor="let rate of rates;let indexOfelement=index;" (click)="showBreakdown(rate)">
            <td>{{rate.year}}</td>
            <td>{{rate.month}}</td>
            <td *ngIf="indexOfelement < rates.length"> {{getTotalInstalls(rate)}} ( {{rate.installs}} +
                {{getPreviousMonth(rate)}} )</td>
            <td *ngIf="indexOfelement > rates.length"> - </td>
            <td>{{rate.inters}}</td>
            <td><strong>{{getTaux(rate)}}</strong></td>
        </tr>
    </table>
</ng-container>
